import React, { useCallback } from 'react';

import jira from 'src/lib/api/jira';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

import { useSelectedIssueTypes, useSelectedProjects } from './RuleFormContext';
const emptyArray = [];

const IssueStatusesSelect = ({ ...props }) => {
  const projects = useSelectedProjects() || emptyArray;
  const issueTypes = useSelectedIssueTypes() || emptyArray;

  const loadOptions = useCallback(async (filter) => {
    const allStatuses = await Promise.all(projects.map(p => jira.getProjectStatuses(p.key)));
    const statuses = allStatuses
      .flat()
      .filter(issueType => issueTypes.some(type => type.id === issueType.id))
      .flatMap(issueType => issueType.statuses || [])
      .filter((item, index, all) => item && all.findIndex(x => x.id === item.id) === index);

    return statuses
      .map(({ name, id }) => ({
        id,
        label: name,
      }));
  }, [projects, issueTypes]);

  const placeholder = projects.length > 0 && issueTypes.length > 0 ? 'Select status...' : 'Please Select Jira project and issue type first';

  return (
    <GenericAsyncSelect
      loadOptions={loadOptions}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default IssueStatusesSelect;
